var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "类型" },
                  model: {
                    value: _vm.searchData.kind,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "kind", $$v)
                    },
                    expression: "searchData.kind"
                  }
                },
                _vm._l(_vm.kindList, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "文档用途" },
                  model: {
                    value: _vm.searchData.document_type,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "document_type", $$v)
                    },
                    expression: "searchData.document_type"
                  }
                },
                _vm._l(_vm.documentTypeList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.label, value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "关系类型" },
                  model: {
                    value: _vm.searchData.relation_type,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "relation_type", $$v)
                    },
                    expression: "searchData.relation_type"
                  }
                },
                [
                  _c("el-option", {
                    attrs: {
                      label: "describes_table",
                      value: "describes_table"
                    }
                  }),
                  _c("el-option", {
                    attrs: { label: "maps_field", value: "maps_field" }
                  }),
                  _c("el-option", {
                    attrs: { label: "maps_entity", value: "maps_entity" }
                  }),
                  _c("el-option", {
                    attrs: { label: "belongs_to", value: "belongs_to" }
                  }),
                  _c("el-option", {
                    attrs: { label: "joins_with", value: "joins_with" }
                  }),
                  _c("el-option", {
                    attrs: { label: "defines_policy", value: "defines_policy" }
                  }),
                  _c("el-option", {
                    attrs: { label: "defines_metric", value: "defines_metric" }
                  }),
                  _c("el-option", {
                    attrs: {
                      label: "provides_sql_pattern",
                      value: "provides_sql_pattern"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "Schema 聚焦" },
                  model: {
                    value: _vm.searchData.schema_linking_focus,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "schema_linking_focus", $$v)
                    },
                    expression: "searchData.schema_linking_focus"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", {
                    attrs: { label: "强制参与", value: "true" }
                  }),
                  _c("el-option", {
                    attrs: { label: "显式禁用", value: "false" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "Embedder" },
                  model: {
                    value: _vm.searchData.document_pipeline_embedder_status,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.searchData,
                        "document_pipeline_embedder_status",
                        $$v
                      )
                    },
                    expression: "searchData.document_pipeline_embedder_status"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", {
                    attrs: { label: "ready", value: "ready" }
                  }),
                  _c("el-option", {
                    attrs: { label: "degraded", value: "degraded" }
                  }),
                  _c("el-option", {
                    attrs: { label: "failed", value: "failed" }
                  }),
                  _c("el-option", {
                    attrs: { label: "skipped", value: "skipped" }
                  }),
                  _c("el-option", {
                    attrs: { label: "missing", value: "missing" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "Indexer" },
                  model: {
                    value: _vm.searchData.document_pipeline_indexer_status,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.searchData,
                        "document_pipeline_indexer_status",
                        $$v
                      )
                    },
                    expression: "searchData.document_pipeline_indexer_status"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", {
                    attrs: { label: "stored", value: "stored" }
                  }),
                  _c("el-option", {
                    attrs: { label: "preview_only", value: "preview_only" }
                  }),
                  _c("el-option", {
                    attrs: { label: "failed", value: "failed" }
                  }),
                  _c("el-option", {
                    attrs: { label: "missing", value: "missing" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "Retriever" },
                  model: {
                    value: _vm.searchData.document_pipeline_retriever_status,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.searchData,
                        "document_pipeline_retriever_status",
                        $$v
                      )
                    },
                    expression: "searchData.document_pipeline_retriever_status"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", {
                    attrs: { label: "ready", value: "ready" }
                  }),
                  _c("el-option", {
                    attrs: { label: "not_indexed", value: "not_indexed" }
                  }),
                  _c("el-option", {
                    attrs: { label: "failed", value: "failed" }
                  }),
                  _c("el-option", {
                    attrs: { label: "missing", value: "missing" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "状态" },
                  model: {
                    value: _vm.searchData.enabled,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "enabled", $$v)
                    },
                    expression: "searchData.enabled"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "全部", value: "" } }),
                  _c("el-option", {
                    attrs: { label: "enabled", value: "true" }
                  }),
                  _c("el-option", {
                    attrs: { label: "disabled", value: "false" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c("el-input", {
                attrs: { clearable: "", placeholder: "关键词" },
                model: {
                  value: _vm.searchData.q,
                  callback: function($$v) {
                    _vm.$set(_vm.searchData, "q", $$v)
                  },
                  expression: "searchData.q "
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.reqLoading },
                  on: {
                    click: function($event) {
                      return _vm.searchClick(1)
                    }
                  }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.$refs.addDocumetItem.open()
                    }
                  }
                },
                [_vm._v("新增")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "sticky-table-header",
              rawName: "v-sticky-table-header",
              value: 0,
              expression: "0"
            },
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.reqLoading,
              expression: "reqLoading"
            }
          ],
          ref: "tableRef",
          attrs: { id: "tableRef", data: _vm.tableData, border: "" }
        },
        [
          _c("el-table-column", { attrs: { prop: "kind", label: "类型" } }),
          _c("el-table-column", { attrs: { prop: "title", label: "标题" } }),
          _c("el-table-column", {
            attrs: { label: "文档/关系", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "cell-info-block" },
                      [
                        scope.row.relation_type
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "info" } },
                              [_vm._v(_vm._s(scope.row.relation_type))]
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "sub-text text-muted" }, [
                          _vm._v(
                            "embedding: " + _vm._s(scope.row._embeddingStr)
                          )
                        ]),
                        _c("div", { staticClass: "sub-text text-muted" }, [
                          _vm._v("priority: " + _vm._s(scope.row.priority))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "影响面", "min-width": "260" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row._impact
                      ? _c("div", { staticClass: "cell-info-block" }, [
                          _c("div", [
                            _c("span", { staticClass: "label-title" }, [
                              _vm._v("schema_focus:")
                            ]),
                            _vm._v(
                              " " +
                                _vm._s(scope.row._impact.schema_linking_focus)
                            )
                          ]),
                          _c("div", [
                            _c("span", { staticClass: "label-title" }, [
                              _vm._v("data_source_id:")
                            ]),
                            _vm._v(
                              " " + _vm._s(scope.row._impact.data_source_id)
                            )
                          ]),
                          scope.row._impact.target_tables &&
                          scope.row._impact.target_tables.length
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "label-title" }, [
                                    _vm._v("tables:")
                                  ]),
                                  _vm._l(
                                    scope.row._impact.target_tables,
                                    function(t, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "t-" + i,
                                          staticClass: "list-item"
                                        },
                                        [_vm._v("- " + _vm._s(t))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          scope.row._impact.target_columns &&
                          scope.row._impact.target_columns.length
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "label-title" }, [
                                    _vm._v("columns:")
                                  ]),
                                  _vm._l(
                                    scope.row._impact.target_columns,
                                    function(c, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "c-" + i,
                                          staticClass: "list-item"
                                        },
                                        [_vm._v("- " + _vm._s(c))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e(),
                          scope.row._impact.context_columns &&
                          scope.row._impact.context_columns.length
                            ? _c(
                                "div",
                                [
                                  _c("div", { staticClass: "label-title" }, [
                                    _vm._v("context_columns:")
                                  ]),
                                  _vm._l(
                                    scope.row._impact.context_columns,
                                    function(cc, i) {
                                      return _c(
                                        "div",
                                        {
                                          key: "cc-" + i,
                                          staticClass: "list-item"
                                        },
                                        [_vm._v("- " + _vm._s(cc))]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            : _vm._e()
                        ])
                      : _c("div", { staticClass: "text-muted" }, [
                          _vm._v("暂无影响面数据")
                        ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "180", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: scope.row.enabled ? "success" : "danger",
                          size: "small"
                        }
                      },
                      [_vm._v(" " + _vm._s(scope.row._statusStr) + " ")]
                    ),
                    _c("div", { staticClass: "sub-text text-muted" }, [
                      _vm._v(
                        "/ " +
                          _vm._s(scope.row.version ? scope.row.version : "-")
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "content", label: "内容", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          placement: "top",
                          disabled: !scope.row.content
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "max-width": "400px",
                              "white-space": "pre-wrap",
                              "word-break": "break-all"
                            },
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [_vm._v(" " + _vm._s(scope.row.content) + " ")]
                        ),
                        _c("div", { staticClass: "three-line-ellipsis" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                scope.row.content ? scope.row.content : "-"
                              ) +
                              " "
                          )
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "280",
              align: "center",
              fixed: "right"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(ref) {
                  var row = ref.row
                  return [
                    _c("div", { staticClass: "x-c" }, [
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.addDocumetItem.open(row)
                            }
                          }
                        },
                        [_vm._v("编辑")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.$refs.reviewDocument.open(row)
                            }
                          }
                        },
                        [_vm._v("Review")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handlePublishEntry(row)
                            }
                          }
                        },
                        [_vm._v("发布")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleRollbackEntry(row)
                            }
                          }
                        },
                        [_vm._v("回滚")]
                      ),
                      _c("div", { staticClass: "controlsBtn-vertical" }),
                      _c(
                        "div",
                        {
                          staticClass: "controlsBtn",
                          on: {
                            click: function($event) {
                              return _vm.handleDisableEntry(row)
                            }
                          }
                        },
                        [_vm._v("禁用")]
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.tableData.length || _vm.searchData.page > 1
        ? _c(
            "div",
            { staticClass: "custom-pagination" },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: _vm.searchData.page === 1 },
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.searchData.page - 1)
                    }
                  }
                },
                [_vm._v(" 上一页 ")]
              ),
              _c("span", { staticClass: "page-num" }, [
                _vm._v("第 " + _vm._s(_vm.searchData.page) + " 页")
              ]),
              _c(
                "el-button",
                {
                  attrs: { size: "small", disabled: !_vm.hasMore },
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.searchData.page + 1)
                    }
                  }
                },
                [_vm._v(" 下一页 ")]
              ),
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px", "margin-left": "15px" },
                  attrs: { size: "small" },
                  on: { change: _vm.sizeChange },
                  model: {
                    value: _vm.searchData.limit,
                    callback: function($$v) {
                      _vm.$set(_vm.searchData, "limit", $$v)
                    },
                    expression: "searchData.limit"
                  }
                },
                [
                  _c("el-option", { attrs: { value: 10, label: "10条/页" } }),
                  _c("el-option", { attrs: { value: 20, label: "20条/页" } }),
                  _c("el-option", { attrs: { value: 50, label: "50条/页" } }),
                  _c("el-option", { attrs: { value: 80, label: "80条/页" } })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("addDocumetItem", {
        ref: "addDocumetItem",
        on: {
          change: function($event) {
            return _vm.searchClick(1)
          }
        }
      }),
      _c("reviewDocument", {
        ref: "reviewDocument",
        on: { change: _vm.getReviewId }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }